// Contenido placeholder del libro - Será reemplazado con el PDF real
export const bookPages = [
  {
    pageNumber: 1,
    title: "Introducción",
    content: `# Cábala para principiantes
## Una guía práctica para el día a día

Por Agustín Mata

---

Bienvenido a un viaje de transformación interior. Este libro te guiará a través de los principios fundamentales de la Cábala, no como una doctrina rígida, sino como una herramienta práctica para tu vida diaria.

La Cábala es un mapa del universo interno y externo. Es el Árbol de la Vida que conecta lo material con lo espiritual, lo cotidiano con lo trascendente.`
  },
  {
    pageNumber: 2,
    title: "¿Qué es la Cábala?",
    content: `# Capítulo 1: ¿Qué es la Cábala?

La Cábala no es magia, no es religión dogmática. Es un sistema de comprensión profunda de cómo funciona la realidad y cómo podemos participar conscientemente en ella.

## Los Orígenes

La palabra "Cábala" viene del hebreo "Qabbalah", que significa "recibir". Es la tradición de recibir sabiduría antigua y aplicarla a la vida moderna.

## El Árbol de la Vida

En el centro de la Cábala está el Árbol de la Vida: un diagrama de 10 esferas (Sefirot) conectadas por 22 caminos. Cada esfera representa un aspecto de la existencia, desde lo más material hasta lo más espiritual.`
  },
  {
    pageNumber: 3,
    title: "Maljut - El Reino Material",
    content: `# Maljut: Tu Punto de Partida

## La Primera Esfera

Maljut es el reino material, tu realidad física. Es donde estás ahora mismo, leyendo estas palabras.

### Ejercicio Práctico

1. Observa tu entorno inmediato
2. Reconoce que TODO lo que ves comenzó como una idea
3. Tu realidad material es el resultado de pensamientos y acciones

**Reflexión**: ¿Qué aspectos de tu vida material quieres transformar? Escribe 3 áreas.`
  },
  {
    pageNumber: 4,
    title: "Yesod - Fundamento y Emociones",
    content: `# Yesod: El Fundamento Emocional

## La Esfera de la Luna

Yesod gobierna tus emociones, tus sueños, tu subconsciente. Es el puente entre lo material (Maljut) y lo mental.

### ¿Por qué importa?

Tus emociones crean tu realidad. Si quieres cambiar tu vida material, primero debes trabajar con tus emociones.

### Práctica Diaria

**Diario Emocional**: Cada noche, escribe:
- 3 emociones que sentiste hoy
- ¿Cuál fue el trigger?
- ¿Cómo respondiste?

Esto desarrolla tu consciencia de Yesod.`
  },
  {
    pageNumber: 5,
    title: "Hod - La Mente Analítica",
    content: `# Hod: El Poder del Intelecto

## Mercurio - La Comunicación

Hod representa tu mente analítica, tu capacidad de razonar, comunicar y comprender patrones.

### Equilibrio Necesario

Muchas personas viven solo en Hod: todo análisis, sin sentimiento. Esto crea desbalance.

**Clave**: Hod sin Netzaj (próxima esfera) es frío. Netzaj sin Hod es caótico.

### Ejercicio de Hod

Toma un problema actual y:
1. Analízalo lógicamente
2. Encuentra 3 soluciones racionales
3. Escribe pros y contras de cada una`
  },
  {
    pageNumber: 10,
    title: "Netzaj - Victoria y Deseo",
    content: `# Netzaj: El Impulso de Crear

## Venus - El Deseo y la Victoria

Netzaj es tu impulso creativo, tus deseos, tu pasión por la vida. Es la fuerza que te mueve hacia adelante.

### El Deseo No Es Malo

La Cábala enseña que el deseo es sagrado. Sin deseo, no hay movimiento, no hay crecimiento.

**Pregunta clave**: ¿Qué deseas verdaderamente?

No lo que "deberías" desear. ¿Qué te hace sentir VIVO?

### Práctica de Netzaj

1. Lista 10 cosas que deseas
2. Pregúntate: ¿Por qué quiero esto?
3. Encuentra el deseo más profundo detrás de cada uno`
  },
  {
    pageNumber: 15,
    title: "Tiferet - Belleza y Balance",
    content: `# Tiferet: El Centro del Árbol

## El Sol - Belleza y Equilibrio

Tiferet es el corazón del Árbol de la Vida. Representa el equilibrio perfecto entre todas las fuerzas.

### ¿Qué es Balance?

No es 50/50 todo el tiempo. Es saber cuándo usar Hod (mente) y cuándo Netzaj (emoción). Cuándo actuar y cuándo esperar.

### El Camino del Medio

Tiferet te enseña:
- No extremos
- Compasión sin debilidad
- Fuerza sin crueldad
- Dar sin vaciarte

**Ejercicio**: Identifica un área desequilibrada en tu vida. ¿Hacia dónde te inclinas? ¿Qué necesitas para balancear?`
  },
  {
    pageNumber: 20,
    title: "Guevurá - Fuerza y Disciplina",
    content: `# Guevurá: El Poder de Decir No

## Marte - Severidad y Límites

Guevurá es la esfera de la fuerza, la disciplina, los límites. Es tu capacidad de decir NO.

### Sin Límites, No Hay Forma

Imagina agua sin recipiente: se desparrama. Guevurá es el recipiente que da forma a tu energía.

### Límites Sanos

- Con otros: Protegen tu energía
- Contigo mismo: Te mantienen enfocado

**Práctica de Guevurá**:

Esta semana:
1. Di NO a algo que no te sirve
2. Establece un límite claro con alguien
3. Disciplínate en una práctica diaria (aunque sean 5 minutos)`
  },
  {
    pageNumber: 25,
    title: "Jesed - Amor y Abundancia",
    content: `# Jesed: La Expansión del Amor

## Júpiter - Misericordia y Dar

Jesed es puro amor, abundancia, el deseo de dar sin esperar nada a cambio.

### El Balance con Guevurá

Jesed sin límites (Guevurá) es codependencia. Guevurá sin amor (Jesed) es crueldad.

Necesitas AMBOS.

### Abundancia Real

Abundancia no es solo dinero. Es:
- Tiempo
- Energía
- Amor
- Conocimiento
- Conexiones

**Práctica de Jesed**:

1. Da algo sin esperar nada (tiempo, dinero, atención)
2. Nota cómo te sientes
3. Pregunta: ¿Desde dónde di? ¿Abundancia o necesidad de validación?`
  },
  {
    pageNumber: 30,
    title: "El Abismo - Da'at",
    content: `# Da'at: El Conocimiento Oculto

## La Esfera Invisible

Da'at no está en el diagrama tradicional del Árbol, pero es crucial. Representa el conocimiento experiencial, no intelectual.

### Cruzar el Abismo

Para seguir ascendiendo en el Árbol, debes cruzar el Abismo: dejar atrás lo que CREES que sabes y abrirte a lo que ES.

**Este es el punto donde muchos se detienen.**

No por falta de información, sino por miedo a soltar la identidad construida.

### ¿Estás listo para continuar?

Lo que viene requiere compromiso real. No es teoría: es transformación.

---

**Continúa leyendo desbloqueando el libro completo...**`
  }
];

// Gamificación: Badges y mensajes motivacionales - 4 niveles
export const gamificationMessages = {
  5: {
    title: "¡Nivel 1 Desbloqueado!",
    message: "Iniciaste el camino. Pocas personas dan el primer paso. ¡Seguí así!",
    badge: "🌱",
    level: 1
  },
  15: {
    title: "¡Subiste al Nivel 2!",
    message: "Ya llevas 15 páginas. Estás construyendo un hábito poderoso. ¡No pares!",
    badge: "⭐",
    level: 2
  },
  25: {
    title: "🎁 ¡Nivel 3 - Regalo Exclusivo!",
    message: "Por tu dedicación, desbloqueamos 10 páginas extra GRATIS. ¡Ahora podés leer hasta la página 40!",
    badge: "🎉",
    level: 3,
    reward: "extra_pages"
  },
  40: {
    title: "🏆 ¡Nivel 4 - Máximo!",
    message: "Completaste las 40 páginas gratis. Demostraste compromiso real. ¿Listo para el viaje completo?",
    badge: "👑",
    level: "MAX"
  }
};